export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=708f1c1e1e4abe8313b61ed19177cca78733060d85&name=pushAdClickData!'